


import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import axios from "axios";
import { BASE_URL } from "../../config/axios";
import { ToastContainer, toast } from "react-toastify";

import usePermission from "../../config/permissions";
// import { handleErrorToast } from "../CustomFunctions";
import {
    AddwithWhiteCircle,
    CheckGreen,
    DeleteDustbin,
    DropdownArrow,
    PDFIcon,
    UpdatePencil,
} from "../AllSvg";

import { formattedDateLong } from "../Date";
import Dashboardnavbarcopy from "../../layout/Dashboardnavbar";
import { formatCurrencyIndian, handleErrorToast } from "../CustomFunctions";

// ! *************** DeductionHeading Crud Models Start ***************



const AddDeductionHeading = ({ getDeductionHeading }) => {
    const [show, setShow] = useState(false);

    const handleClose = () => {
        setFormData({
            name: '',
            sub_company: "",
            division: '',
        });
        setShow(false);
    };
    const handleShow = () => {
        getSubCompany();
        getDivision();
        setShow(true);
    };
    const months = [
        { text: "January", value: 1 },
        { text: "February", value: 2 },
        { text: "March", value: 3 },
        { text: "April", value: 4 },
        { text: "May", value: 5 },
        { text: "June", value: 6 },
        { text: "July", value: 7 },
        { text: "August", value: 8 },
        { text: "September", value: 9 },
        { text: "October", value: 10 },
        { text: "November", value: 11 },
        { text: "December", value: 12 },
    ];

    const currentYear = new Date().getFullYear();
    const years = Array.from({ length: 10 }, (_, i) => currentYear - i);

    const [formData, setFormData] = useState({
        name: '',
        division: '',
        sub_company: "",
        type: '',
        deduction_for: '',
        deduction_category: '',
    });

    // console.log(formData.DeductionHeading_type)

    // !  ************** Validation start **************  ! //

    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});

    const validateForm = () => {
        const newErrors = {};

        const requiredFields = [
            "name",
            // "sub_company"

            // formData.DeductionHeading_type === "Monthbywise" ? "month" : null,
            // formData.DeductionHeading_type === "Monthbywise" ? "year" : null,
            // formData.DeductionHeading_type === "ProjectbyWise" ? "project" : null,
            // formData.DeductionHeading_type === "ProjectbyWise" ? "employee" : null,
        ];


        requiredFields.forEach((field) => {
            console.log(formData[field]);
            if (!formData[field]) {
                newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
                    } is required !`;
            }
        });

        setErrors(newErrors);
        console.log(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    // ?  ************** Validation End **************  ! //
    const [loading, setLoading] = useState(false); //loading logic

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (validateForm()) {
            setLoading(true); //loading logic
            const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

            try {

                let res = await axios.post(
                    `${BASE_URL}/siteproject/deductionheading/`,
                    formData
                );

                if (res.status === 200) {
                    await getDeductionHeading();
                    handleClose();
                    toast.dismiss(loadingToastId);
                    toast.success("DeductionHeading added successfully!");
                } else {
                    toast.dismiss(loadingToastId);
                    toast.error("Failed to add DeductionHeading!");
                }
            } catch (err) {
                //toast Logic
                handleErrorToast(err);
            } finally {
                setLoading(false); //loading logic
                toast.dismiss(loadingToastId);
            }
        } else {

        }
    };

    const handleInputChange = (e) => {
        const { name, value, type, files } = e.target;
        // console.log(files[0])
        let newValue;
        if (type === "file") {
            console.log("file", files[0]);
            newValue = files.length > 0 ? files : null;
        } else {
            newValue = value;
        }

        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        });
        // if (name === "DeductionHeading_type") {
        //     setFormData({
        //         ...FormData,
        //         [name]: newValue,
        //         month: "",
        //         project: "",
        //     });
        // }
        // setFormData({
        //     ...formData,
        //     [name]: newValue,
        // });
        setFormData({
            ...formData,
            [name]: newValue,
        });
    };

    const [subcompanyList, setSubCompanyList] = useState([]);
    const getSubCompany = async () => {
        try {
            const response = await axios.get(`${BASE_URL}/siteproject/subcompany/`);
            setSubCompanyList(response.data);
        } catch (error) {
            alert(error);
        }
    }


    const [divisionList, setDivisionList] = useState([]);
    const getDivision = async () => {
        try {
            const response = await axios.get(`${BASE_URL}/siteproject/divisiongetpost/`);
            setDivisionList(response.data);
        } catch (error) {
            alert(error);
        }
    }


    return (
        <>
            <button
                title="Add Deduction Heading"
                className="upload-svg"
                onClick={handleShow}
            >
                <AddwithWhiteCircle /> DeductionHeading
            </button>

            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="request-leave"
            >
                <Modal.Header
                    closeButton
                    className="justify-center task-Tab-heading font-weight500    font-size-heading "
                >
                    <Modal.Title> Add Deduction Heading</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form className="register-from">
                        <div className="form-flex-wrap">
                            <div className="flex-column">
                                <label
                                    htmlFor="name"
                                    className="form-labels font-weight500 announce-date font-weight400 font-size-heading"
                                    title="name"
                                >
                                    Name:<span className="required">*</span>
                                </label>
                                <input
                                    placeholder="Name"
                                    title="name"
                                    type="text"
                                    name="name"
                                    onChange={handleInputChange}
                                    value={formData.name}
                                    className={`form-input font-weight400 font-size-subheading form-input-background ${errors.name
                                        ? "error"
                                        : inputState.name
                                            ? "success"
                                            : ""
                                        }`}
                                />
                                {errors.name && (
                                    <span className="error-message font-size-text">
                                        {errors.name}
                                    </span>
                                )}
                            </div>

                            <div className="flex-column form-group-select">
                                <label className="form-labels font-weight500 font-size-subheading">
                                    Division:<span className="required">*</span>
                                </label>

                                <select
                                    name="division"
                                    value={formData.division}
                                    onChange={handleInputChange}
                                    className={`form-input form-group-selection ${errors.division
                                        ? "error"
                                        : inputState.division
                                            ? "success"
                                            : ""
                                        }`}
                                >
                                    <option value="">Select a Division</option>
                                    {divisionList.map((company) => (
                                        <option value={company.id}>{company.name}</option>
                                    ))}
                                </select>

                                {errors.division && (
                                    <span className="error-message">
                                        {errors.division}
                                    </span>
                                )}
                            </div>

                            <div className="flex-column form-group-select">
                                <label className="form-labels font-weight500 font-size-subheading">
                                    Type:<span className="required">*</span>
                                </label>
                                <br />
                                <select
                                    name="type"
                                    value={formData.type}
                                    onChange={handleInputChange}
                                    className={`form-input form-group-selection ${errors.type
                                        ? "error"
                                        : inputState.type
                                            ? "success"
                                            : ""
                                        }`}
                                >
                                    <option value="">Select Type</option>
                                    <option value="Allowance">Allowance</option>
                                    <option value="Deduction">Deduction</option>
                                </select>

                                {errors.type && (
                                    <span className="error-message">
                                        {errors.type}
                                    </span>
                                )}
                            </div>

                            <div className="flex-column form-group-select">
                                <label className="form-labels font-weight500 font-size-subheading">
                                    Deduction For:<span className="required">*</span>
                                </label>
                                <br />
                                <select
                                    name="deduction_for"
                                    value={formData.deduction_for}
                                    onChange={handleInputChange}
                                    className={`form-input form-group-selection ${errors.type
                                        ? "error"
                                        : inputState.type
                                            ? "success"
                                            : ""
                                        }`}
                                >
                                    <option value="">Select Deduction</option>
                                    <option value="Vehicle">Vehicle</option>
                                    <option value="OfficeRent">OfficeRent</option>
                                    <option value="Invoice">Invoice</option>
                                </select>

                                {errors.type && (
                                    <span className="error-message">
                                        {errors.type}
                                    </span>
                                )}
                            </div>

                            <div className="flex-column form-group-select">
                                <label className="form-labels font-weight500 font-size-subheading">
                                    Deduction Category:<span className="required">*</span>
                                </label>
                                <br />
                                <select
                                    name="deduction_category"
                                    value={formData.deduction_category}
                                    onChange={handleInputChange}
                                    className={`form-input form-group-selection ${errors.type
                                        ? "error"
                                        : inputState.type
                                            ? "success"
                                            : ""
                                        }`}
                                >
                                    <option value="">Select Category</option>
                                    <option value="Including">Including</option>
                                    <option value="Excluding">Excluding</option>
                                </select>

                                {errors.type && (
                                    <span className="error-message">
                                        {errors.type}
                                    </span>
                                )}
                            </div>

                        </div>
                    </form>
                    <div className="button-models">
                        <button
                            className="model-button font-weight500 model-button-cancel"
                            onClick={handleClose}
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            className="model-button font-weight500 model-button-leave font-weight500 font-size-heading"
                            onClick={handleSubmit}
                            disabled={loading}
                        >
                            Add
                        </button>
                    </div>

                    <ToastContainer
                        position="top-center"
                        autoClose={1000}
                        hideProgressBar={false}
                        newestOnTop={true}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />
                </Modal.Body>
            </Modal>
        </>
    );
};

const UpdateDeductionHeading = ({ i, getDeductionHeading }) => {
    const [show, setShow] = useState(false);

    const handleClose = () => {
        setFormData({
            name: '',
            sub_company: "",
        });
        setShow(false);
    };
    const handleShow = () => {
        getSubCompany();
        getDivision()
        setFormData(i);
        setShow(true);
    };
    const months = [
        { text: "January", value: 1 },
        { text: "February", value: 2 },
        { text: "March", value: 3 },
        { text: "April", value: 4 },
        { text: "May", value: 5 },
        { text: "June", value: 6 },
        { text: "July", value: 7 },
        { text: "August", value: 8 },
        { text: "September", value: 9 },
        { text: "October", value: 10 },
        { text: "November", value: 11 },
        { text: "December", value: 12 },
    ];

    const currentYear = new Date().getFullYear();
    const years = Array.from({ length: 10 }, (_, i) => currentYear - i);

    const [formData, setFormData] = useState({
        name: '',
        division: '',
        type: '',
    });

    // console.log(formData.DeductionHeading_type)

    // !  ************** Validation start **************  ! //

    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});

    const validateForm = () => {
        const newErrors = {};

        const requiredFields = [
            "name",
            "division",
            "type"

            // formData.DeductionHeading_type === "Monthbywise" ? "month" : null,
            // formData.DeductionHeading_type === "Monthbywise" ? "year" : null,
            // formData.DeductionHeading_type === "ProjectbyWise" ? "project" : null,
            // formData.DeductionHeading_type === "ProjectbyWise" ? "employee" : null,
        ];


        requiredFields.forEach((field) => {
            console.log(formData[field]);
            if (!formData[field]) {
                newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
                    } is required !`;
            }
        });

        setErrors(newErrors);
        console.log(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    // ?  ************** Validation End **************  ! //
    const [loading, setLoading] = useState(false); //loading logic

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (validateForm()) {
            setLoading(true); //loading logic
            const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

            try {

                let res = await axios.put(
                    `${BASE_URL}/siteproject/deductionheading/${i.id}/`,
                    formData
                );

                if (res.status === 200) {
                    await getDeductionHeading();
                    handleClose();
                    toast.dismiss(loadingToastId);
                    toast.success("DeductionHeading added successfully!");
                } else {
                    toast.dismiss(loadingToastId);
                    toast.error("Failed to add DeductionHeading!");
                }
            } catch (err) {
                //toast Logic
                handleErrorToast(err);
            } finally {
                setLoading(false); //loading logic
                toast.dismiss(loadingToastId);
            }
        } else {

        }
    };

    const handleInputChange = (e) => {
        const { name, value, type, files } = e.target;
        // console.log(files[0])
        let newValue;
        if (type === "file") {
            console.log("file", files[0]);
            newValue = files.length > 0 ? files : null;
        } else {
            newValue = value;
        }

        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        });
        // if (name === "DeductionHeading_type") {
        //     setFormData({
        //         ...FormData,
        //         [name]: newValue,
        //         month: "",
        //         project: "",
        //     });
        // }
        // setFormData({
        //     ...formData,
        //     [name]: newValue,
        // });
        setFormData({
            ...formData,
            [name]: newValue,
        });
    };

    const [subcompanyList, setSubCompanyList] = useState([]);
    const getSubCompany = async () => {
        try {
            const response = await axios.get(`${BASE_URL}/siteproject/subcompany/`);
            setSubCompanyList(response.data);
        } catch (error) {
            alert(error);
        }
    }

    const [divisionList, setDivisionList] = useState([]);
    const getDivision = async () => {
        try {
            const response = await axios.get(`${BASE_URL}/siteproject/divisiongetpost/`);
            setDivisionList(response.data);
        } catch (error) {
            alert(error);
        }
    }


    return (
        <>
            <button
                title="Edit DeductionHeading Details"
                className="model-edit-button"
                onClick={handleShow}
            >
                <UpdatePencil /> {" "}

            </button>

            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="request-leave"
            >
                <Modal.Header
                    closeButton
                    className="justify-center task-Tab-heading font-weight500    font-size-heading "
                >
                    <Modal.Title> Update DeductionHeading</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form className="register-from">
                        <div className="form-flex-wrap">
                            <div className="flex-column">
                                <label
                                    htmlFor="name"
                                    className="form-labels font-weight500 announce-date font-weight400 font-size-heading"
                                    title="name"
                                >
                                    Name:<span className="required">*</span>
                                </label>
                                <input
                                    placeholder="Name"
                                    title="name"
                                    type="text"
                                    name="name"
                                    onChange={handleInputChange}
                                    value={formData.name}
                                    className={`form-input font-weight400 font-size-subheading form-input-background ${errors.name
                                        ? "error"
                                        : inputState.name
                                            ? "success"
                                            : ""
                                        }`}
                                />
                                {errors.name && (
                                    <span className="error-message font-size-text">
                                        {errors.name}
                                    </span>
                                )}
                            </div>


                            <div className="flex-column form-group-select">
                                <label className="form-labels font-weight500 font-size-subheading">
                                    Division:<span className="required">*</span>
                                </label>

                                <select
                                    name="division"
                                    value={formData.division}
                                    onChange={handleInputChange}
                                    className={`form-input form-group-selection ${errors.division
                                        ? "error"
                                        : inputState.division
                                            ? "success"
                                            : ""
                                        }`}
                                >
                                    <option value="">Select a Division</option>
                                    {divisionList.map((company) => (
                                        <option value={company.id}>{company.name}</option>
                                    ))}
                                </select>

                                {errors.division && (
                                    <span className="error-message">
                                        {errors.division}
                                    </span>
                                )}
                            </div>


                            <div className="flex-column form-group-select">
                                <label className="form-labels font-weight500 font-size-subheading">
                                    Type:<span className="required">*</span>
                                </label>
                                <br />
                                <select
                                    name="type"
                                    value={formData.type}
                                    onChange={handleInputChange}
                                    className={`form-input form-group-selection ${errors.type
                                        ? "error"
                                        : inputState.type
                                            ? "success"
                                            : ""
                                        }`}
                                >
                                    <option value="">Select Type</option>
                                    <option value="allowance">Allowance</option>
                                    <option value="deduction">Deduction</option>
                                </select>

                                {errors.type && (
                                    <span className="error-message">
                                        {errors.type}
                                    </span>
                                )}
                            </div>


                        </div>
                    </form>
                    <div className="button-models">
                        <button
                            className="model-button font-weight500 model-button-cancel"
                            onClick={handleClose}
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            className="model-button font-weight500 model-button-leave font-weight500 font-size-heading"
                            onClick={handleSubmit}
                            disabled={loading}
                        >
                            Update
                        </button>
                    </div>

                    <ToastContainer
                        position="top-center"
                        autoClose={1000}
                        hideProgressBar={false}
                        newestOnTop={true}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />
                </Modal.Body>
            </Modal>
        </>
    );
};



const DeleteDeductionHeading = ({ i, getDeductionHeading }) => {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => {
        setShow(true);
    };

    const handleFormSubmitDelete = async (e) => {
        e.preventDefault();
        const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

        try {
            let res = await axios.delete(
                `${BASE_URL}/siteproject/deductionheading/${i.id}/`
            );

            if (res.status === 200) {
                await getDeductionHeading();
                setShow(false);
                toast.dismiss(loadingToastId);
                toast.success("DeductionHeading deleted successfully");
            } else {
                alert(res);
            }
        } catch (err) {
            //toast Logic
            handleErrorToast(err);
        } finally {
            toast.dismiss(loadingToastId);
        }
    };

    return (
        <>
            <button
                title="Delete DeductionHeading"
                className="model-delete-button"
                onClick={handleShow}
            >
                <DeleteDustbin />
            </button>

            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="request-leave width-40vw"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Delete DeductionHeading of "{i.name}"</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        Are You Sure You Want to delete DeductionHeading ?
                        <div className="button-models">
                            <button
                                className="model-button   font-weight500    model-button-cancel "
                                onClick={handleClose}
                            >
                                Cancel
                            </button>
                            <button
                                onClick={handleFormSubmitDelete}
                                className="model-button   font-weight500    model-button-delete"
                            >
                                Delete
                            </button>
                        </div>
                    </div>
                    <ToastContainer
                        position="top-center"
                        autoClose={1000}
                        hideProgressBar={false}
                        newestOnTop={true}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />
                </Modal.Body>
            </Modal>
        </>
    );
};

const DeductionHeading = () => {
    const [buffer, setBuffering] = useState(true); //buffering logic

    const [toggleStatus, setToggleStatus] = useState("null");
    const [DeductionHeadingData, setDeductionHeadingData] = useState([]);

    const getDeductionHeading = async () => {
        setBuffering(true); // Start Buffering
        let url;
        try {
            url = `${BASE_URL}/siteproject/deductionheadingfilter/${toggleStatus}/`;

            const sub = await axios.get(url);

            setDeductionHeadingData(sub.data);
        } catch (err) {
            handleErrorToast(err); // Toast Logic
        } finally {
            setBuffering(false); // End Buffering
        }
    };

    useEffect(() => {
        getDeductionHeading();
    }, [toggleStatus]);
    const months = [
        { text: "January", value: 1 },
        { text: "February", value: 2 },
        { text: "March", value: 3 },
        { text: "April", value: 4 },
        { text: "May", value: 5 },
        { text: "June", value: 6 },
        { text: "July", value: 7 },
        { text: "August", value: 8 },
        { text: "September", value: 9 },
        { text: "October", value: 10 },
        { text: "November", value: 11 },
        { text: "December", value: 12 },
    ];

    const role = sessionStorage.getItem("role");
    const department = sessionStorage.getItem('department')

    const [projectListData, setProjectList] = useState([]);

    const getProjectListData = async () => {
        setBuffering(true); //buffering logic // Start Buffering
        try {
            const res = await axios.get(
                `${BASE_URL}/siteproject/projectfilterbysubcompany/null/`
            );
            setProjectList(res.data);
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering(false); // End Buffering
        }
    };

    useEffect(() => {
        getProjectListData();
    }, []);

    const [divisionData, setdivisionData] = useState([]);

    const getDivision = async () => {
        setBuffering(true); // Start Buffering
        let url;
        try {
            url = `${BASE_URL}/siteproject/divisiongetpost/`;

            const sub = await axios.get(url);

            setdivisionData(sub.data);
        } catch (err) {
            handleErrorToast(err); // Toast Logic
        } finally {
            setBuffering(false); // End Buffering
        }
    };

    useEffect(() => {
        getDivision()
    }, [])
    return (
        <>



            <div className="table-css-white-background" style={{ padding: "34px 30px" }}>
                <div className="table-heading-flex">
                    <div className="repo-heading font-weight500 font-size-heading">
                        DeductionHeading
                    </div>
                    <div className="field-cont">
                        <div className="table-searchh dropdown-container field-cont-div">
                            <select
                                onChange={(e) => setToggleStatus(e.target.value)}
                                value={toggleStatus}
                                className="dropdown font-size-subheading  "
                            >
                                {divisionData.map((company) => (
                                    <option value={company.id}>{company.name}</option>
                                ))}
                            </select>
                        </div>

                        <AddDeductionHeading
                            getDeductionHeading={getDeductionHeading}
                            DeductionHeadingList={DeductionHeadingData}
                        />
                    </div>
                </div>
                {/* <DeductionHeadingsDetailForm /> */}
                <div className="table-box height-73vh">
                    <table className="table-css">
                        <thead className="table-heading">
                            <tr className="custom-table-head-tr ">
                                <th className="align-left">Sr.No.</th>
                                <th className="align-center">Name</th>

                                <th className="align-center">Division</th>
                                <th className="align-center">Type</th>
                                <th className="align-center width-5vw">Action</th>
                            </tr>
                        </thead>
                        {buffer ? (
                            <div className="spinner-bgdatil"></div>
                        ) : (
                            <tbody>
                                {DeductionHeadingData
                                    // ?.filter((e) =>
                                    //     e.status === toggleStatus
                                    // )
                                    // .sort((a, b) =>
                                    //     a.booking_date.localeCompare(b.booking_date, "en", { ignorePunctuation: true })
                                    // )
                                    .map((i, index) => (
                                        <React.Fragment key={index}>
                                            <tr className="tr-border-bottom">
                                                <td colSpan="6"></td>
                                            </tr>
                                            <tr className="custom-table-head-td">
                                                <td className="align-left">{index + 1}</td>
                                                <td className="align-center">{i.name}</td>
                                                {/* <td className="align-center ">
                                                        {i.DeductionHeading_type ? i.DeductionHeading_type : "-"}
                                                    </td> */}
                                                <td className="align-center form-text-trasformation-uppercase">
                                                    {i.division ? i.divison_name : '-'}
                                                </td>
                                                <td className="align-center form-text-trasformation-uppercase">
                                                    {i.type ? i.type : '-'}
                                                </td>



                                                <td className="align-center">

                                                    <div className=" flex-row justify-evenly">
                                                        <UpdateDeductionHeading
                                                            i={i}
                                                            getDeductionHeading={getDeductionHeading}
                                                        />
                                                        <DeleteDeductionHeading
                                                            i={i}
                                                            getDeductionHeading={getDeductionHeading}
                                                        />
                                                    </div>




                                                </td>
                                            </tr>
                                        </React.Fragment>
                                    ))}
                            </tbody>
                        )}
                    </table>
                </div>
                <ToastContainer
                    position="top-center"
                    autoClose={1000}
                    hideProgressBar={false}
                    newestOnTop={true}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                />
            </div>

        </>
    );
};

export default DeductionHeading;
